import { EDIT_BASKET_MEALS_FIRST_STAGE } from 'lib/constants';
import {
  GET_QUICK_FILTERS_V3_REQUEST,
  GET_QUICK_FILTERS_V3_RESPONSE,
  GET_QUICK_FILTERS_V3_ERROR,
} from 'lib/constants/v3Actions';
import { FILTER_SUFFIX } from 'reducers/mealFilters';
import { getStageStepKey } from 'helpers/stageSteps';

const initialState = {
  loading: false,
  failed: false,
  stageStep1: [],
  stageStep2: [],
};

const toMealFilter = quickFilter => {
  const defaultValue = { [quickFilter.filterValue]: true };

  const filters =
    quickFilter.filterValues?.length > 0
      ? quickFilter.filterValues.reduce((acc, current) => {
          acc[current] = true;
          return acc;
        }, {})
      : defaultValue;

  return {
    filter: `${quickFilter.filterName}${FILTER_SUFFIX}`,
    value: filters,
    isQuickFilter: true,
  };
};

const transformQuickFilters = quickFilters => {
  return quickFilters.map(qf => ({ ...qf, toMealFilter: toMealFilter(qf) }));
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_QUICK_FILTERS_V3_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_QUICK_FILTERS_V3_RESPONSE:
      return {
        ...state,
        loading: false,
        isFetched: true,
        stageStep1: transformQuickFilters(action.response.quickFilters.stageStep1),
        stageStep2: transformQuickFilters(action.response.quickFilters.stageStep2),
      };
    case GET_QUICK_FILTERS_V3_ERROR:
      return {
        ...state,
        loading: false,
        failed: true,
        stageStep1: [],
        stageStep2: [],
      };
    default:
      return state;
  }
};

export const selectQuickFilters = (state, stageStep = null) =>
  stageStep
    ? state[getStageStepKey(stageStep)]
    : state[getStageStepKey(EDIT_BASKET_MEALS_FIRST_STAGE)];
export const selectQuickFiltersLoading = state => state.loading;
export const selectQuickFiltersFailed = state => state.failed || false;
export const selectQuickFiltersIsFetched = state => state.isFetched || false;
